import { useMemo } from 'react';

import { useAddonsQuery } from './GraphQL/Addons.generated';

export const useAddons = () => {
  const [addonsResponse, refetchAddons] = useAddonsQuery({
    requestPolicy: 'network-only',
  });

  const isLoadingAddons = addonsResponse.fetching || addonsResponse.stale;
  const addons = addonsResponse.data?.addons;

  return useMemo(
    () => ({ addons, isLoadingAddons, refetchAddons }),
    [addons, isLoadingAddons, refetchAddons],
  );
};
